/**
 * Return a URL with its protocol stripped:
 *
 * http://example.com -> example.com
 * https://example.com -> example.com
 *
 * @param url {string}
 * @return {string}
 */
export default function stripUrlProtocol(url) {
  if (url != null) {
    return url.replace(/(^\w+:|^)\/\//, '');
  }
  return url;
}
